import { Controller } from "@hotwired/stimulus";

declare global {
  interface Window {
    HubSpotConversations?: { widget: { open: () => void } };
    hsConversationsOnReady?: (() => void)[];
  }
}

export default class SupportChatController extends Controller {
  open(): void {
    if (window.HubSpotConversations) {
      window.HubSpotConversations.widget.open();
      return;
    }
    window.hsConversationsOnReady = [
      ...(window.hsConversationsOnReady ?? []),
      () => window.HubSpotConversations?.widget.open(),
    ];
  }
}
